import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavBarButton from "../buttons/NavBarButton";
import Space from "../layout/Space";
import { logoutUser, useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById } from "../models/OrgFunctions";
import PrimaryButton from "../buttons/PrimaryButton";
import { useAppContext } from "../config/AppContext";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getRefFromId,
} from "../models/DataFunctions";
import DropDownOrg from "../dropdowns/DropDownOrg";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";
import { signInWithCustomToken } from "firebase/auth";
import { getAuth } from "firebase/auth";
import { EasySwitch } from "../textfields/EasySwitch";
import Tippy from "@tippyjs/react";
import { Spin } from "antd";
import updateDocApi from "../api/database/updateDocApi";
import TextField2 from "../textfields/TextField2";
import { User } from "../types/user";
import { Org, Workspace } from "../types/org";
import type { User as FirebaseUser } from "firebase/auth";
import SmallSpinner from "../loading/SmallSpinner";

interface NavBarProps {
  actualpage: string;
  userData: User;
  orgData: Org;
  masterData: Org;
  local_version: string;
  override_id?: string | null;
  navigateWorkspace: (...args: any[]) => void;
  workspaceData?: Workspace | null;
  handleLogout: () => void;
  handleLoginAs: (id: string) => void;
}

function NavBar({
  actualpage,
  userData,
  orgData,
  masterData,
  local_version,
  override_id = null,
  navigateWorkspace,
  workspaceData,
  handleLogout,
  handleLoginAs,
}: NavBarProps) {
  const { currentUser, loading } = useAuth() as {
    currentUser: FirebaseUser | null;
    loading: boolean;
  }; // add types  const { appState, setAppState, resetAppStateLogin } = useAppContext();

  const location = useLocation();
  const [url, setUrl] = useState("http://127.0.0.1:8000/");
  const [showWorkspaces, setShowWorkspaces] = useState(false);
  const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
  const { appState, setAppState } = useAppContext();

  const [messageNewVersion, setMessageNewVersion] = useState(false);
  const [client_notify, setClientNotify] = useState(false);
  const [vote_object, setVoteObject] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleWorkspace, setIsVisibleWorkspace] = useState(false);

  const [isProd, setIsProd] = useState(false);
  const [settings_open, setSettingsOpen] = useState<any>(false);

  useEffect(() => {
    setIsVisible(settings_open);
  }, [settings_open]);
  useEffect(() => {
    setIsVisibleWorkspace(showWorkspaces);
  }, [showWorkspaces]);

  const handleFetchData = async () => {
    if (userData && currentUser) {
      if (orgData.type !== "master") {
        let workspaces = (await getArrayDocDataByRef(
          orgData.workspaces_id
        )) as any as Workspace[];
        setWorkspaces(workspaces);

        if (location.pathname.includes("workspace")) {
          let workspace = workspaces.find(
            (w) =>
              w.id === location.pathname.split("workspace")[1].split("/")[1]
          );
          let selected_workspace = workspace;
          if (!selected_workspace) {
            navigateWorkspace("abort_override");
            return;
          }
          const master = (await getOrgById(workspace?.master_id)) as Org;

          // if override
          if (override_id) {
            const overriding_master_user = (await getDocDataById(
              "user",
              currentUser?.uid
            )) as any as User;
            const overriding_master = (await getOrgById(
              overriding_master_user.org_id
            )) as Org;

            if (master.id !== overriding_master.id) {
              console.warn(
                `this master ${master.id} is not the same as the workspace master ABORT OVERRIDE`
              );
              // this master who is overriding should not be able to see the workspace
              navigateWorkspace("abort_override");

              return;
            }
          }
        }
      }
    }
  };

  const handleSwitchWorkspace = async (workspace: Workspace) => {
    // check if already in a workspace

    navigateWorkspace("/home", orgData, workspace.id);
  };

  useEffect(() => {
    handleFetchData(); // Fetch user data when currentUser is available
    setUrl(appState.dev_url);
  }, [userData, orgData, masterData, currentUser]); // Dependency array ensures this runs when currentUser changes

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen w-screen">
        <SmallSpinner></SmallSpinner>
      </div>
    ); // Show loading state while checking auth or if currentUser is null
  }

  // <div className="flex flex-row  max-w-full pl-1 mr-5 text-gray-800 text-h3  bg-neutral-100   rounded-md  border-1   ">
  //{orgData.name}
  // </div>

  return (
    <div className="flex flex-col  h-full w-60 min-w-60 bg-transparent pointer-events-auto p-2 ">
      {settings_open && (
        <div
          onClick={() => setSettingsOpen(false)}
          className="fixed h-screen w-screen  top-0 left-0  z-50 flex justify-center items-center"
        >
          <div
            className={`absolute bottom-4 z-40 w-c200 flex flex-col ${
              isVisible ? "scale-100 opacity-100 " : "scale-90 opacity-0"
            }  duration-75 transition-all   h-fit text-shadow_50 border-1 border-shadow_10  bg-white p-4 shadow-xl rounded-lg`}
            style={{ left: "230px" }}
          >
            <div className="flex flex-row gap-2 items-center ">
              <div className="h-10 w-10  min-h-10 min-w-10 rounded-full bg-indigo-50 flex items-center justify-center text-white">
                {settings_open.photo && (
                  <img
                    src={
                      settings_open.photo || "https://via.placeholder.com/150"
                    }
                    className="h-10 w-10 rounded-full"
                  ></img>
                )}
              </div>
              <div className="flex flex-col ">
                <div className="text-h3 font-semibold">
                  {settings_open.display_name}
                </div>
                <div className="text-h4 ">
                  {settings_open.email.substring(0, 15)}
                </div>
              </div>
            </div>
            {settings_open.niveau && (
              <div
                onClick={() => {
                  navigateWorkspace("/facturation?upgrade=true");
                  setSettingsOpen(false);
                }}
                className="flex flex-row cursor-pointer mt-4 gap-2  w-fit pr-4 items-center p-2 bg-primary rounded-lg"
              >
                <Icon1 icon_name="stars" size={20} fill="#ffffff" />
                <div className="text-h3 font-semibold text-white">
                  Mettre à niveau
                </div>
              </div>
            )}

            <div
              onClick={() => {
                navigateWorkspace("/account");
                setSettingsOpen(false);
              }}
              className="flex flex-row gap-2 w-full pr-4 mt-4 p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="user" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Compte</div>
            </div>
            <div
              onClick={() => {
                navigateWorkspace("/organisation");
                setSettingsOpen(false);
              }}
              className="flex flex-row gap-2 w-full pr-4 p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="organisation" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Entreprise</div>
            </div>

            <div
              onClick={() => {
                navigateWorkspace("/account");

                setSettingsOpen(false);
              }}
              className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="settings" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Paramètres</div>
            </div>
            <div
              onClick={handleLogout}
              className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
            >
              <Icon1 icon_name="logout" size={20} fill="grey" />
              <div className="text-h3 font-semibold ">Déconnexion</div>
            </div>
          </div>
        </div>
      )}

      <div className="flex max-w-full h-full max-h-full  flex-col  bg-neutral-50 rounded-md border-1 border-neutral-200  ">
        <div className="relative flex flex-col pl-5 gap-1 flex-1 max-h-full  pr-4 max-w-full overflow-y-auto">
          <Space y={15} />
          <div className="flex flex-row gap-3 items-center ml-1">
            <div className="relative">
              <Icon1 icon_name="hexagone-logement" size={24}></Icon1>
            </div>
            <div className="text-primary select-none text-h2">
              hexagone <span className="font-semibold">logement</span>
            </div>{" "}
          </div>
          <Space y={20} />
          <div className="absolute top-1 right-1 text-h6 h-0 text-shadow_10 hover:text-shadow_50 duration-500">
            v.
            {local_version?.substring(6, 8) +
              "/" +
              local_version?.substring(4, 6) +
              "/" +
              local_version?.substring(8, 10) +
              "h" +
              local_version?.substring(10, 12)}
          </div>
          {/* Navigation buttons */}
          {orgData.logement?.access?.can_create === true && (
            <NavBarButton
              icon="home"
              isActualPage={location.pathname.includes("/home")}
              onClick={() => navigateWorkspace("/home", orgData)}
            >
              Accueil
            </NavBarButton>
          )}
          <NavBarButton
            icon="logement"
            isActualPage={location.pathname.includes("carnet")}
            onClick={() => navigateWorkspace("/carnets", orgData)}
          >
            Carnets
          </NavBarButton>{" "}
          {/* <NavBarButton
            icon="user"
            isActualPage={location.pathname.includes("partner")}
            onClick={() => navigateWorkspace("/partners", orgData)}
          >
            Partenaires
          </NavBarButton> */}
          <NavBarButton
            icon="bookshelf"
            isActualPage={location.pathname.includes("/bibliotheque")}
            onClick={() => navigateWorkspace("/bibliotheque", orgData)}
          >
            Bibliothèque
          </NavBarButton>
          {/* <NavBarButton
            icon="card"
            isActualPage={location.pathname.includes("/recharge")}
            onClick={() => navigateWorkspace("/recharge", orgData)}
          >
            Recharger
          </NavBarButton> */}
          <NavBarButton
            icon="settings"
            onClick={() => navigateWorkspace("/parameters", orgData)}
            isActualPage={[
              "/account",
              "/organisation",
              "/facturation",
              "/products",
              "/devisparams",
              "/controlparams",
              "/stripe",
              "/infiltrea",
              "/parameters",
              "chauffage",
              "/rtb",
              "/xml",
              "/email",
              "/perso",
              "/tags",
              "/formparams",
              "/validation",
              "/mobileapp",
              "/gallery",
              "/invitemanager",
              "/reminders",
              "/pennylane",
              "/packs",
              "/masters",
            ].includes(
              location.pathname.includes("workspace")
                ? "/" + location.pathname.split("workspace")[1].split("/")[2]
                : location.pathname
            )}
          >
            Paramètres
          </NavBarButton>
          <Space y={30}></Space>
          {/* Admin-specific buttons */}
          {userData.admin && (
            <div className="flex flex-col gap-0">
              <NavBarButton
                icon="home"
                squeezed={true}
                onClick={() => navigateWorkspace("/admin/dashboard", orgData)}
                isActualPage={location.pathname === "/admin/dashboard"}
              >
                Dashboard
              </NavBarButton>
              <NavBarButton
                icon="logs"
                squeezed={true}
                onClick={() => navigateWorkspace("/admin/logs", orgData)}
                isActualPage={location.pathname === "/admin/logs"}
              >
                Logs
              </NavBarButton>{" "}
              <NavBarButton
                icon="payments"
                squeezed={true}
                onClick={() =>
                  navigateWorkspace("/admin/admin-payments", orgData)
                }
                isActualPage={location.pathname === "/admin/admin-payments"}
              >
                Paiements
              </NavBarButton>
              <NavBarButton
                icon="user"
                squeezed={true}
                onClick={() => navigateWorkspace("/admin/users", orgData)}
                isActualPage={location.pathname === "/admin/users"}
              >
                Utilisateurs
              </NavBarButton>
              <NavBarButton
                icon="organisation"
                squeezed={true}
                onClick={() => navigateWorkspace("/admin/orgs", orgData)}
                isActualPage={location.pathname === "/admin/orgs"}
              >
                Orgs
              </NavBarButton>
              <Space y={10}></Space>
              <div className="flex flex-row items-center gap-2 p-0 m-0">
                <div className="text-h3 text-shadow_50 font-medium">Local</div>
                <EasySwitch
                  checked={appState.dev}
                  onChange={(checked: any) =>
                    setAppState((prevState: any) => ({
                      ...prevState,
                      dev: checked,
                    }))
                  }
                />
              </div>
              {appState.dev && (
                <div className="pr-5">
                  <TextField2
                    label="url"
                    value={url}
                    onChange={(e: any) => setUrl(e.target.value)}
                    className="text-h3 text-shadow_50"
                  ></TextField2>
                </div>
              )}
            </div>
          )}
          <Space y={10}></Space>
        </div>
        <div className="flex flex-col justify-end    w-full relative ">
          {userData.admin && (
            <div className=" flex flex-row gap-2">
              <SecondaryButton
                onClick={() => handleLoginAs("1aihbaoDIBetJDTXNuVnWXnguiF3")}
              >
                OEC
              </SecondaryButton>
              <SecondaryButton
                onClick={() => handleLoginAs("OChVGuPmZGS0mZGriZ1J9x5fm4F2")}
              >
                DER
              </SecondaryButton>
              <SecondaryButton
                onClick={() => handleLoginAs("TIKZNJtFNdNz4xfoHq5bkURA7l12")}
              >
                JAD
              </SecondaryButton>
              <SecondaryButton
                onClick={() => handleLoginAs("CIbjhJGQZaeQYuEfxbymvFwyBx83")}
              >
                ABC
              </SecondaryButton>
            </div>
          )}
          {userData.id === "TIKZNJtFNdNz4xfoHq5bkURA7l12" && (
            <div className=" flex flex-row gap-2">
              <SecondaryButton
                onClick={() => handleLoginAs("CIbjhJGQZaeQYuEfxbymvFwyBx83")}
              >
                ABC
              </SecondaryButton>
            </div>
          )}
          {userData.id === "CIbjhJGQZaeQYuEfxbymvFwyBx83" && (
            <div className=" flex flex-row gap-2">
              <SecondaryButton
                onClick={() => handleLoginAs("TIKZNJtFNdNz4xfoHq5bkURA7l12")}
              >
                JAD
              </SecondaryButton>
            </div>
          )}{" "}
          {showWorkspaces && (
            <div
              className="fixed select-none h-screen w-screen top-0 left-0  z-50 flex justify-center items-center"
              onClick={() => setShowWorkspaces(false)}
            >
              <div
                className={`absolute  ${
                  isVisibleWorkspace
                    ? "scale-100 opacity-100 "
                    : "scale-90 opacity-0"
                }
             bottom-24 z-40 w-c300 flex flex-col duration-75 transition-all   h-fit text-shadow_50 border-1 border-shadow_10  bg-white p-1 shadow-xl rounded-lg`}
                style={{ left: "220px" }}
              >
                <div className="flex flex-col gap-1">
                  {workspaces?.map((workspace, index) => (
                    <div
                      onClick={() =>
                        workspace.id === workspaceData?.id
                          ? {}
                          : handleSwitchWorkspace(workspace)
                      }
                      key={index}
                      className={`flex flex-row gap-2 items-center   p-2 rounded-md   ${
                        workspace.id === workspaceData?.id
                          ? "bg-teal-50 border-l-2 border-teal-500 "
                          : "bg-white hover:bg-teal-100 cursor-pointer"
                      }`}
                    >
                      <div className="text-h3 text-shadow_50">
                        {workspace.master_name}
                      </div>
                    </div>
                  ))}
                </div>{" "}
              </div>
            </div>
          )}
          <div
            onClick={() =>
              setSettingsOpen(
                settings_open
                  ? null
                  : {
                      display_name: userData?.display_name,
                      email: userData?.email,
                      photo: userData?.photo,
                      type: orgData?.type,
                      niveau:
                        orgData?.type === "master" &&
                        orgData?.facturation?.plan !== "premium",
                    }
              )
            }
            className="flex flex-row  select-none cursor-pointer max-w-full justify-between gap-3 p-2 m-2  items-center rounded-md hover:bg-neutral-100 "
          >
            <div className="flex flex-row gap-3 max-w-full">
              <div className=" min-w-10 h-10 rounded-full bg-white flex justify-center relative">
                <img
                  className="w-10 h-10 rounded-full object-center object-contain "
                  src={
                    userData?.photo ||
                    "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                  }
                ></img>
              </div>
              <div className="flex flex-col flex-grow max-w-full ">
                <div className="text-h3 text-nowrap text-black text-ellipsis overflow-hidden select-none max-w-24">
                  {userData.display_name}
                </div>
                <div
                  className="text-h6 text-shadow_50
            max-h-4  text-ellipsis overflow-hidden select-none max-w-24
              "
                >
                  {userData.email}
                </div>
              </div>{" "}
            </div>
            <div className="">
              <Icon1 icon_name="settings" size={20} fill="grey"></Icon1>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

export default NavBar;
